module.exports = __webpack_public_path__ + "static/adc-e844c5eae431f9c9c4f45428eec34ef6.png";